import React, { useEffect, useState } from 'react'
import { FaFutbol, FaCopy, FaClock, FaEdit } from "react-icons/fa";
import { LoadingSpinner } from "../../components";
import goalResultService from "../../services/goalResultService";
import moment from 'moment/moment';
import { setToastMessage } from '../../reducers/common.reducer';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import { useWindowWidth } from '@react-hook/window-size';
import { EventSourcePolyfill } from 'event-source-polyfill';
import GoalResultEditModal from '../goalResult/components/GoalResultEditModal';
import { Alert, Box, Button, LinearProgress, Tooltip } from '@mui/material';
import DetailsLog from './components/DetailsLog';
import CustomCalendarSVG from '../../components/CustomCalendarSVG';
import CustomSearchBtn from '../../components/CustomSearchBtn';
import CustomNoData from '../../components/CustomNoData';

const title = ["Goal Result"];

function LinearProgressWithLabel(props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary" className='dark:text-customWhite'>{props.name}</Typography>
            </Box>
            <Box sx={{ width: '100%', mr: 1, ml:1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary" className='dark:text-customWhite'>{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

const UpdateResult = (props) => {
    const { activeTitle, apis } = props;
    const dispatch = useDispatch();
    const onlyWidth = useWindowWidth();
    const [isLoading, setIsLoading] = useState(false);
    const [date, setDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [showResultList, setShowResultList] = useState([]);
    const [open, setOpen] = useState(false);
    const [openLog, setOpenlog] = useState(false);
    const [messages, setMessages] = useState([]);
    const [noti, setNoti] = useState({ status: 0, msg: '' });
    const [selectedInfo, setSelectedInfo] = useState(null);
    const [totalCount, setTotalCount] = useState({ single: 0, mix: 0 })
    const [progressSingle, setProgressSingle] = useState(0);
    const [progressMix, setProgressMix] = useState(0);

    useEffect(() => {
        getAllGoalResult();
        setNoti({ status: 0, msg: 'Recalculation process is not started now.' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTitle])

    // useEffect(() => {
    //     const timer = setInterval(() => {
    //         setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
    //     }, 800);
    //     return () => {
    //         clearInterval(timer);
    //     };
    // }, []);

    const handleSearch = async () => {
        try {
            getAllGoalResult();
        }
        catch (error) {
            console.log({ error });
        } finally {

        }
    }

    const getAllGoalResult = async () => {
        try {
            setIsLoading(true);
            const payload = {
                selectedDate: date
            }
            const goalResultList = await goalResultService.getResultWithVouchers(apis.getApi, payload);

            if (goalResultList.data.status !== 403) {
                const formattedValue = goalResultList.data.payload.sort((a, b) => a.event - b.event);
                console.log("test value", goalResultList.data.singleCountTotal)
                setTotalCount({ single: goalResultList.data.singleCountTotal || 0, mix: goalResultList.data.mixCountTotal || 0 });
                setShowResultList(formattedValue.filter(a => a.homeGoal !== "NE" && a.awayGoal !== "NE"));
            }

        } catch (error) {
            console.log({ error });
        } finally {
            setIsLoading(false);
        }
    }

    const handleCopy = (v) => {
        navigator.clipboard.writeText(`${v.league} ${v.homeTeam} VS ${v.awayTeam}`);
    }

    const handleEdit = async (IsPostPoned, IsOverLimit, hresult, aresult, EventId) => {
        try {
            setIsLoading(true);
            setOpen(false);
            setNoti({ msg: "Goal result is processing ... ", status: 1 });
            const payload = {
                IsPostPoned,
                IsOverLimit,
                EventId,
                HomeResult: hresult,
                AwayResult: aresult
            }

            //console.log("final payload", payload, apis.editResultApi);
            const response = await goalResultService.updateGoalResult(apis.editResultApi, payload);
            //const response = await goalResultService.updateGoalResult("https://localhost:44356/api/GoalsResultEdit/goal-result-choice", payload);

            if (!response.data.success) {
                dispatch(setToastMessage({ message: response.data.message }));
            }
            else {
                setNoti({ msg: "Goal result is completed", status: 0 });
                fetchStream(response.data.token, response.data.rapidEventId, response.data.previousPostponed);
            }
        }
        catch (error) {
            dispatch(setToastMessage({ message: error.response.data.message }))
            //console.log("here error",error );
        }
        finally {
            setIsLoading(false);
        }
    }

    const fetchStream = async (token, rapid, isPostPoned) => {
        //console.log("token", token);
        setNoti({ msg: "Recalculation is processing ... ", status: 1 });
        const eventSource = new EventSourcePolyfill(`${apis.recalStreamApi}?eventId=${rapid}&previousPostponed=${isPostPoned}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            heartbeatTimeout: 60000, // set to 1 minute (60,000 ms)
        });

        eventSource.onmessage = (e) => {
            const data = e.data;

            if (data === "[DONE]") {
                eventSource.close();
                setNoti({ msg: "Recalculation is completed ... ", status: 0 });
                setMessages((prev) => [...prev,data])
                setProgressSingle(100);
                setProgressMix(100);
                getAllGoalResult();
                return;
            }

            if (data.startsWith("ERROR")) {
                setMessages((prev) => [...prev, `❌ ${data}`]);
                eventSource.close();
                return;
            }

            // Expected format: `PROGRESS:20|Your message`
            const parts = data.split("|");
            if (parts.length === 2 && parts[0].startsWith("SINGLE PROGRESS:")) {
                const percent = parseInt(parts[0].replace("SINGLE PROGRESS:", ""));
                setProgressSingle((prevProgress) => (prevProgress + percent));
               // setMessages((prev) => [...prev, parts[1]]);
            }
            else if (parts.length === 2 && parts[0].startsWith("MIX PROGRESS:")) {
                const percent = parseInt(parts[0].replace("MIX PROGRESS:", ""));
                setProgressMix((prevProgress) => (prevProgress + percent));
               // setMessages((prev) => [...prev, parts[1]]);
            } 
            else {
                setMessages((prev) => [...prev, data]);
            }
        };

        eventSource.onerror = (err) => {
            if (err.status === 401) {
                dispatch(setToastMessage({ message: "Token error!" }));
            }
            if (err.error) {
                dispatch(setToastMessage({ message: err.error.message }));
            }
            if (err.error === undefined) {
                // setMessages((prev) => [
                //     ...prev,
                //     `❌ Internal server error occured.`
                // ]);
            }

            console.error("Streaming error:", err);
            eventSource.close();
        };
    };

    const handleClear = () => {
        setMessages([]);
        setProgressSingle(0);
        setProgressMix(0);
        setNoti({ status: 0, msg: 'Recalculation process is not started now.' })
    }

    return (
        <div className='w-full max-w-7xl h-full px-2 customFontRoboto'>
            <GoalResultEditModal
                handleSave={handleEdit}
                open={open}
                setOpen={setOpen}
                selectedInfo={selectedInfo}
                isMobile={onlyWidth < 480}
            />
            <DetailsLog
                open={openLog}
                handleClear={handleClear}
                setOpen={setOpenlog}
                messages={messages}
                isMobile={onlyWidth < 480}
            />
            <div className='my-1 flex flex-col'>
                <div className='text-sm sticky top-0 z-10 bg-customGray dark:bg-custom_dark_background'>
                    <div className={`flex flex-wrap ${onlyWidth < 480 ? 'gap-1' : 'justify-between'} items-center`}>
                        <div className={`flex ${onlyWidth < 480 ? 'gap-1' : 'gap-2'}`}>
                            <div className={`relative flex ${onlyWidth < 480 ? 'w-32 text-xs' : 'w-44 text-sm'} justify-center rounded-sm bg-customTitleColor mb-1 dark:bg-custom_dark_primary2`}>
                                <input
                                    className="bg-customTitleColor dark:bg-custom_dark_primary2 font-semibold text-gray-700 px-5 py-2 rounded-md border border-gray-200 dark:border-custom_dark_primary shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-gray-100 transition duration-300 ease-in-out w-full cursor-pointer dark:text-customWhite"
                                    type="date"
                                    value={date}
                                    onChange={e => setDate(e.target.value)}
                                />
                                <CustomCalendarSVG />
                            </div>
                            {/* <button
                                className='text-white dark:text-customLightYellow px-5 py-1 my-2 hover:bg-customForeColor rounded-sm bg-slate-900 dark:bg-custom_dark_primary font-semibold dark:border-custom_dark_primary2'
                                onClick={() => handleSearch()}
                            >
                                Search
                            </button> */}
                            <CustomSearchBtn handleSearch={handleSearch}/>
                        </div>
                        {/* <Badge badgeContent={mixCount} color="primary">
                            <span className='text-gray-700 font-semibold text-sm'>Mix Vouchers</span>
                        </Badge> */}
                        <div className='flex flex-col gap-1'>
                            <span className='px-2 rounded-sm items-center cursor-pointer bg-yellow-100 text-yellow-800 dark:bg-customLightYellow dark:text-customBlack'>Total Single - {totalCount.single}</span>
                            <span className='px-2 rounded-sm items-center cursor-pointer bg-teal-100 text-teal-800 dark:bg-customTurquosie dark:text-customWhite'>Total Mix - {totalCount.mix}</span>
                        </div>
                        {/* <div className={`flex w-[150px] mx-2 rounded-sm bg-customTitleColor items-center text-sm`}>
                            <div className='main-wrapper relative group'>
                                <div className="flex w-[150px] rounded-sm items-center bg-customTitleColor cursor-pointer">
                                    <span className="flex justify-center items-center w-[90%] bg-customTitleColor font-semibold">
                                        {selectedFilter?.label}
                                    </span>
                                    <img className="w-8" src={expendArrow} alt="" />
                                </div>
                                <ul className='w-full absolute group-hover:block hidden  border px-5 py-2 bg-white'>
                                    {
                                        filterType && filterType.map((v, i) => {
                                            return (
                                                <li key={i} className={`p-3 text-center border-b-2 ${i === filterType.length - 1 ? null : 'border-customFontGreen'} text-customFontGreen cursor-pointer`} onClick={() => handleSelect(v)}> {v.label} </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div> */}
                    </div>
                    <Alert
                        severity={`${noti.status === 0 ? "success" : "warning"}`}
                        className='mt-1 dark:bg-customTurquosie'
                        action={
                            <Button color="inherit" size="small"  className="dark:text-customGray" onClick={() => setOpenlog(prev => !prev)}>
                                Show Details
                            </Button>
                        }
                    >
                        <span className='dark:text-customWhite'>{noti.msg}</span>
                    </Alert>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgressWithLabel value={progressSingle} color="success" name="Single"/>
                    </Box>
                     <Box sx={{ width: '100%' }}>
                        <LinearProgressWithLabel value={progressMix} color="info" name="Mix"/>
                    </Box>
                </div>
                <main className="flex-1 flex justify-center min-h-[15rem]">
                    {
                        isLoading ? <LoadingSpinner />
                            :
                            <table className="border-separate border-spacing-2 w-[100%]">
                                <thead>
                                    <tr>
                                        {
                                            title && title.map((v, i) => {
                                                return (
                                                    <th className={`border border-slate-300 py-1 text-sm bg-background text-white dark:border-custom_dark_primary dark:bg-custom_dark_primary2`} key={i}>{v}</th>
                                                )
                                            })
                                        }
                                        {/* <th className="border border-slate-300 py-3 px-1 w-[10%] bg-background text-white">Action</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        showResultList.length > 0 ? showResultList.map((v, i) => {
                                            const score = Number(v.homeGoal) < 0 && Number(v.awayGoal) < 0 ? 'PP - PP' : `${v.homeGoal} - ${v.awayGoal}`;
                                            return (
                                                <tr key={i}>
                                                    <td className="border border-slate-300 pb-1 rounded-md dark:bg-custom_dark_primary2 dark:border-custom_dark_primary">
                                                        <div className='flex justify-between py-2 px-1'>
                                                            <span className={`${onlyWidth < 480 ? 'text-xs' : 'text-sm'} flex items-center gap-1 text-customFontGreen`}>
                                                                <FaFutbol />{v.league}  <FaCopy onClick={() => handleCopy(v)} className='cursor-pointer text-customFontGold' />
                                                            </span>
                                                            {
                                                                onlyWidth > 480 ?
                                                                    <div className={`flex gap-1 ${onlyWidth < 480 ? 'text-[12px]' : 'text-sm'}`}>
                                                                        <span className='flex px-2 rounded-sm items-center cursor-pointer bg-yellow-100 text-yellow-800 dark:bg-customLightYellow dark:text-customBlack'>
                                                                            {/* <FaFile className='text-sm'/> - {v.activeVoucherCount}*/}
                                                                            Single - {v.finishedVoucherCount}
                                                                        </span>
                                                                        <span className='flex px-2 rounded-sm items-center cursor-pointer bg-teal-100 text-teal-800 dark:bg-customTurquosie dark:text-customWhite'>
                                                                            {/* <FaFileAlt  className='text-sm'/> - {v.totalVoucherCount} */}
                                                                            Mix - {v.finishedMixVoucherCount}
                                                                        </span>
                                                                    </div> : null
                                                            }
                                                        </div>
                                                        <div className='flex'>
                                                            {
                                                                onlyWidth > 480 ?
                                                                    <span className="text-xs flex items-center gap-1 w-[12%] text-background ml-1 italic font-semibold dark:text-customWhite"><FaClock />{moment(v.event).format("YYYY-MM-DD / hh:mm a")}</span> : null
                                                            }
                                                            <div className={`flex justify-center ${onlyWidth < 480 ? 'text-xs w-[35%]' : 'text-sm w-[30%]'} text-customFontVoilet font-semibold dark:text-customOrange`}>{v.homeTeam}</div>
                                                            <div className="flex justify-center items-center w-[30%]">
                                                                <span className={`text-center ${onlyWidth < 480 ? 'text-sm' : 'text-base'} ${Number(v.homeGoal) < 0 && Number(v.awayGoal) < 0 ? 'text-red-600' : 'text-black'} font-extrabold dark:text-customWhite`}>
                                                                    {score}
                                                                </span>
                                                                <Tooltip title="Edit and Recalculate" placement="top" arrow>
                                                                    <span onClick={() => { setOpen(true); setSelectedInfo(v) }} >
                                                                        <FaEdit className='cursor-pointer text-sm ml-2 text-customFontGreen' size={18} />
                                                                    </span>
                                                                </Tooltip>
                                                            </div>
                                                            <div className={`flex justify-center ${onlyWidth < 480 ? 'text-xs w-[35%]' : 'text-sm w-[30%]'} text-customFontVoilet font-semibold dark:text-customOrange`}>{v.awayTeam}</div>
                                                        </div>
                                                        {onlyWidth > 480 ? null :
                                                            <div className='w-full flex justify-between mt-2 px-2'>
                                                                <span className="text-xs flex items-center gap-1 text-primary ml-1 italic dark:text-customWhite"><FaClock />{moment(v.event).format("YYYY-MM-DD / hh:mm a")}</span>
                                                                <div className={`flex gap-1 ${onlyWidth < 480 ? 'text-[12px]' : 'text-sm'}`}>
                                                                    <div className='flex px-2 rounded-md items-center cursor-pointer text-sm bg-yellow-200 text-yellow-800 dark:bg-customLightYellow dark:text-customBlack'>
                                                                        {/* <FaFile className='text-sm'/> - {v.activeVoucherCount} */}
                                                                        Single - {v.finishedVoucherCount}
                                                                    </div>
                                                                    <div className='flex px-2 rounded-md items-center cursor-pointer text-sm bg-teal-200 text-teal-800 dark:bg-customTurquosie dark:text-customWhite'>
                                                                        {/* <FaFileAlt   className='text-sm'/> - {v.totalVoucherCount} */}
                                                                        Mix - {v.finishedMixVoucherCount}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        }) : 
                                        // <div className='flex justify-center items-center'>
                                        //     <p className='text-customBlack dark:text-customWhite'>No Data Found !</p>
                                        // </div>
                                        <CustomNoData />
                                    }
                                </tbody>
                            </table>
                    }
                </main>
            </div>
        </div>
    )
}

export default UpdateResult;

// focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2